<div class="playbooks-list">
    <div class="playbooks-list-actions">
        <app-playbooks-filters
            [pageFilters]="pageFilters"
            [withCreateButton]="(playbooksRowViewModel$ | async)?.length !== 0 && (isLoading$ | async) === false"
            [playbooksCount]="totalPlaybooks">
        </app-playbooks-filters>
    </div>

    <div class="header">
        <div class="items-amount" *ngIf="totalPlaybooks > -1">
            {{ "common.found" | labelsProvider }} {{ totalPlaybooks | number }}
            {{ "menu.playbooksPage" | labelsProvider | lowercase }}
        </div>
    </div>

    <div class="rows" *ngIf="(isLoading$ | async) === false && !showNoData">
        <div class="rows-columns">
            <div class="col col-name sortable-columns" (click)="onColumnSortClick(sortableColumns.Name)">
                {{ "zenityCommon.playbook" | labelsProvider }}
                {{ "common.name" | labelsProvider }}
                <img
                    src="assets/images/common/sort-icon.svg"
                    [ngClass]="{
                        'sort-inactive': selectedSort.key !== sortableColumns.Name,
                        'sort-asc': selectedSort.key === sortableColumns.Name && !selectedSort.isDesc,
                    }" />
            </div>
            <div class="col col-created sortable-columns" (click)="onColumnSortClick(sortableColumns.CreatedAt)">
                {{ "playbooks.created" | labelsProvider }}
                <img
                    src="assets/images/common/sort-icon.svg"
                    [ngClass]="{
                        'sort-inactive': selectedSort.key !== sortableColumns.CreatedAt,
                        'sort-asc': selectedSort.key === sortableColumns.CreatedAt && !selectedSort.isDesc,
                    }" />
            </div>
            <div class="col col-integration">
                {{ "zenityCommon.integration" | labelsProvider }}
            </div>
            <div class="col col-policies">
                {{ "zenityCommon.policies" | labelsProvider }}
            </div>
            <div class="col col-execution sortable-columns" (click)="onColumnSortClick(sortableColumns.LastExecutionAt)">
                {{ "playbooks.lastExecution" | labelsProvider }}
                <img
                    src="assets/images/common/sort-icon.svg"
                    (click)="onColumnSortClick(sortableColumns.LastExecutionAt)"
                    [ngClass]="{
                        'sort-inactive': selectedSort.key !== sortableColumns.LastExecutionAt,
                        'sort-asc': selectedSort.key === sortableColumns.LastExecutionAt && !selectedSort.isDesc,
                    }" />
            </div>
            <div class="col col-status sortable-columns" (click)="onColumnSortClick(sortableColumns.Status)">
                {{ "playbooks.status" | labelsProvider }}
                <img
                    src="assets/images/common/sort-icon.svg"
                    [ngClass]="{
                        'sort-inactive': selectedSort.key !== sortableColumns.Status,
                        'sort-asc': selectedSort.key === sortableColumns.Status && !selectedSort.isDesc,
                    }" />
            </div>
        </div>
        <div class="rows-container">
            <div class="rows-container-row" *ngFor="let playbookRow of playbooksRowViewModel$ | async">
                <div (click)="onPlaybookRowClick(playbookRow)" class="rows-container-row-dynamic">
                    <div class="col-name" appLongTextTooltip>
                        {{ playbookRow.name }}
                        <app-status-label
                            class="playbook-status-label"
                            *ngIf="playbookRow.executionCalculatedStatus"
                            [statusLabel]="playbookRow.executionCalculatedStatus"
                            [matTooltip]="'playbooks.playbookWarningMessage' | labelsProvider">
                        </app-status-label>
                    </div>
                    <div class="col-created">
                        On {{ playbookRow.createdAt | date: "mediumDate" }}
                        <br />
                        by
                        {{ playbookRow.createdBy }}
                    </div>
                    <div class="col-integration">
                        <img class="icon" [src]="playbookRow.platformIconPath" />
                        <div class="integration-name">
                            {{ playbookRow.integration }}
                        </div>
                    </div>
                    <div class="col-policies">
                        <app-table-cell-array [data]="playbookRow.policies"></app-table-cell-array>
                    </div>
                    <div class="col-execution">
                        {{
                            playbookRow.lastExecutionAt ? (playbookRow.lastExecutionAt | date: "medium") : ("playbooks.noExecutions" | labelsProvider)
                        }}
                    </div>
                    <div class="col-status">
                        <app-status-label [statusLabel]="playbookRow.statusLabelEnum"> </app-status-label>
                    </div>
                </div>
                <app-actions-menu-icon
                    *ngIf="playbookRow.menuActions"
                    class="col-menu"
                    [actions]="playbookRow.menuActions"
                    (actionOnClick)="actionOnClick($event, playbookRow)"
                    [smallSize]="true">
                </app-actions-menu-icon>
            </div>
        </div>
    </div>
    <div *ngIf="(isLoading$ | async) && (playbooksRowViewModel$ | async)?.length === 0" class="loading">
        <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
    <div *ngIf="showNoData && filtersAreEmpty && (isLoading$ | async) === false" class="empty">
        <div class="empty-icon">
            <img src="assets/images/menu-icons/playbooks.svg" />
        </div>
        <div class="empty-text">
            {{ "playbooks.firstTime" | labelsProvider }}
        </div>
        <a class="empty-button" routerLink="/app/playbooks/new">
            <img src="assets/images/common/create.svg" />
            <div>
                {{ ("common.create" | labelsProvider).toUpperCase() }}
                {{ ("zenityCommon.playbook" | labelsProvider).toUpperCase() }}
            </div>
        </a>
    </div>
    <div *ngIf="showNoData && !filtersAreEmpty && (isLoading$ | async) === false" class="empty">
        <app-no-data [tableNotFoundText]="'playbooks.emptyResults' | labelsProvider" tableNotFoundIcon="assets/images/common/no-results-found.svg">
        </app-no-data>
    </div>
</div>
